export const FicheType = ({type, style, className, ...props}) => {
    return type && type != "" && <div className={`type`} style={style} >
        <span>
            {props.children} {type}
        </span>
    </div>;
}